// /app/product-options/490898
// /app/customize/order/13652828
// agent id: 378b485f08
// Need refreshed tokenId in the get-template-conf API, and check the host to match in base mock-next-apis.ts file

import {waitTimeout} from "@Common/utils/wait-timeout";

import {tokenId} from "./token-id";

export const CcApis3Mock = ({host}) => ({
    // scriptUrl: "/app/mock/cc/IframeApi.js",
    scriptUrl: host + "/Resources/Generated/IframeApi.js",
    getHost: () => ({ccHost: "123"}),
    getHighResProducts1: async () => {
        await waitTimeout(500);
        return {
            jpg: [
                "https://picsum.photos/seed/gtg33/300/200",
                "https://picsum.photos/seed/f34y5/300/200",
            ],
        };
    },
    getTemplateConf: async () => ({
        "colorSet": {},
        "customFieldsData": {"Front": [], "Back": []},
        "editorConfigurations": {
            "userId": "ff644376-610a-417c-a010-64f86a4b7acb",
            "canvasOnlyMode": true,
            "initialMode": "Simple",
            "spellCheckEnabled": true,
            "preloader": {"enabled": false},
            "canvas": {"rulers": {"enabled": false}},
            "widgets": {
                "AssetManager": {
                    "tabs": [{
                        "name": "Designation Gallery",
                        "assetSourceInstance": "Designation Gallery",
                        "iconClassName": "cc-icon-add-image"
                    }, {
                        "name": "Agent Logo Gallery",
                        "assetSourceInstance": "Agent Logo Gallery",
                        "iconClassName": "cc-icon-add-image"
                    }, {
                        "name": "Headshot Gallery",
                        "assetSourceInstance": "Headshot Gallery",
                        "iconClassName": "cc-icon-add-image"
                    }, {
                        "name": "Property Photos",
                        "assetSourceInstance": "Property Photos",
                        "iconClassName": "cc-icon-add-image"
                    }, {
                        "name": "Image Gallery",
                        "assetSourceInstance": "Image Gallery",
                        "iconClassName": "cc-icon-uploadable",
                        "controls": {"toolbarEnabled": false}
                    }, {
                        "name": "Headshot Upload Gallery",
                        "assetSourceInstance": "Headshot Upload Gallery",
                        "iconClassName": "cc-icon-uploadable",
                        "controls": {"toolbarEnabled": false}
                    }, {
                        "name": "Logo Upload Gallery",
                        "assetSourceInstance": "Logo Upload Gallery",
                        "iconClassName": "cc-icon-uploadable",
                        "controls": {"toolbarEnabled": false}
                    }, {
                        "name": "Property Upload Gallery",
                        "assetSourceInstance": "Property Upload Gallery",
                        "iconClassName": "cc-icon-uploadable",
                        "controls": {"toolbarEnabled": false}
                    }]
                }
            },
            "defaultAssetSelectWidget": "AssetManager",
            "assetSources": {
                "Image Gallery": {
                    "type": "PrivateSource",
                    "allowedExtensions": ["jpg", "jpeg", "png", "svg", "pdf"],
                    "actionMode": {"svg": "Shape", "pdf": "Vector"}
                },
                "Headshot Upload Gallery": {
                    "type": "PrivateSource",
                    "allowedExtensions": ["jpg", "jpeg", "png", "svg", "pdf"],
                    "path": "headshots",
                    "actionMode": {"svg": "Shape", "pdf": "Vector"}
                },
                "Logo Upload Gallery": {
                    "type": "PrivateSource",
                    "allowedExtensions": ["jpg", "jpeg", "png", "svg", "pdf"],
                    "path": "logos",
                    "actionMode": {"svg": "Shape", "pdf": "Vector"}
                },
                "Property Upload Gallery": {
                    "type": "PrivateSource",
                    "allowedExtensions": ["jpg", "jpeg", "png", "svg", "pdf"],
                    "path": "508a4df0-e1ee-11ec-b01b-8f25eb9cd594",
                    "actionMode": {"svg": "Shape", "pdf": "Vector"}
                },
                "Property Photos": {"type": "MemorySource", "rootCategory": {"assets": []}},
                "Headshot Gallery": {"type": "MemorySource", "rootCategory": {"assets": []}},
                "Agent Logo Gallery": {"type": "MemorySource", "rootCategory": {"assets": []}},
                "Designation Gallery": {"type": "MemorySource", "rootCategory": {"assets": []}}
            },
            tokenId,
            "productThemes": {
                "One Headshot": {
                    "Back-H0": {"visible": "false"},
                    "Back-H1": {"visible": "true"},
                    "Back-H2": {"visible": "false"},
                    "Back-H3": {"visible": "false"},
                    "Back-Team": {"visible": "false"},
                    "Back-H1Only": {"visible": "true"},
                    "Back-H2Only": {"visible": "false"}
                },
                "0 headshots": {
                    "Back-H0": {"visible": "true"},
                    "Back-H1": {"visible": "false"},
                    "Back-H2": {"visible": "false"},
                    "Back-H3": {"visible": "false"},
                    "Back-Team": {"visible": "false"},
                    "Back-H1Only": {"visible": "false"},
                    "Back-H2Only": {"visible": "false"}
                }
            }
        },
        "galleries": {
            "Property Photos": {
                "title": "caption",
                "source": "pictureUrl",
                "binding": "xd.listing.pictures",
                "preview": "thumbUrl"
            },
            "Headshot Gallery": {
                "title": "name",
                "source": "imageUrl",
                "binding": "xd.user.imageGallery.headshots",
                "preview": "thumbnailUrl"
            },
            "Agent Logo Gallery": {
                "title": "name",
                "source": "imageUrl",
                "binding": "xd.user.imageGallery.logos",
                "preview": "thumbnailUrl"
            },
            "Designation Gallery": {
                "title": "name",
                "source": "imageUrl",
                "binding": "xd.company.imageGallery.designations",
                "preview": "thumbnailUrl"
            }
        },
        "productDefinition": {
            "surfaces": [{
                "name": "Front",
                "printAreas": [{"designFile": "Templates/191017/1528/86adec07-a475-409a-bee6-a6eccb8ef058/86adec07-a475-409a-bee6-a6eccb8ef058"}]
            }, {
                "name": "Back",
                "printAreas": [{"designFile": "Templates/191017/1528/f573c6fd-3711-4580-a93a-118f8bc88bb1/f573c6fd-3711-4580-a93a-118f8bc88bb1"}]
            }]
        },
        "rotations": ["", ""],
        "styleBindingData": {"Front": {}, "Back": {"field01": {"tags": ["Back-H1"]}}},
        "styleConfigurations": {
            "Front": {},
            "Back": {
                "Headshots": {
                    "One Headshot": {
                        "Back-H0": {"visible": "false"},
                        "Back-H1": {"visible": "true"},
                        "Back-H2": {"visible": "false"},
                        "Back-H3": {"visible": "false"},
                        "Back-Team": {"visible": "false"},
                        "Back-H1Only": {"visible": "true"},
                        "Back-H2Only": {"visible": "false"}
                    },
                    "0 headshots": {
                        "Back-H0": {"visible": "true"},
                        "Back-H1": {"visible": "false"},
                        "Back-H2": {"visible": "false"},
                        "Back-H3": {"visible": "false"},
                        "Back-Team": {"visible": "false"},
                        "Back-H1Only": {"visible": "false"},
                        "Back-H2Only": {"visible": "false"}
                    }
                }
            }
        },
        "styleDefaults": {"Back": {"Headshots": "0 headshots"}},
        "templateBindingData": {
            "Front": {
                "field01": {
                    "type": "image",
                    "value": "{{xd.listing.pictures.0.pictureUrl}}",
                    "gallery": "Property Photos"
                },
                "field02": {
                    "type": "inlineVariable",
                    "value": "{{xd.listing.location.streetAddress}}, {{xd.listing.location.city}}, {{xd.listing.location.state}} {{xd.listing.location.zip}}\n${{xd.listing.listedPrice}}\n{{xd.listing.bedrooms}} Beds, {{xd.listing.bathrooms}} Baths, {{xd.listing.livingArea}} SQ.FT."
                },
                "field03": {"type": "customVariable", "value": "{{xd.event.value.eventLabel}}"}
            }, "Back": {
                "field01": {
                    "type": "image",
                    "value": "{{#if xd.user.defaultHeadshot}}{{xd.user.defaultHeadshot}}{{else}}{{xd.user.imageGallery.headshots.0.imageUrl}}{{/if}}",
                    "imageTag": "headshot1"
                },
                "field02": {"type": "standardVariable", "value": "{{xd.user.agentDisplay1}}"},
                "field03": {
                    "type": "inlineVariable",
                    "value": "{{#if xd.user.agentDisplay2}}{{xd.user.agentDisplay2}}\n{{/if}}{{#if xd.user.agentDisplay3}}{{xd.user.agentDisplay3}}\n{{/if}}{{#if xd.user.agentDisplay4}}{{xd.user.agentDisplay4}}\n{{/if}}{{#if xd.user.agentDisplay5}}{{xd.user.agentDisplay5}}\n{{/if}}{{#if xd.user.agentDisplay6}}{{xd.user.agentDisplay6}}\n{{/if}}{{#if xd.user.agentDisplay7}}{{xd.user.agentDisplay7}}\n{{/if}}{{#if xd.user.agentDisplay8}}{{xd.user.agentDisplay8}}{{/if}}"
                },
                "field04": {
                    "type": "inlineVariable",
                    "value": "{{xd.event.value.eventLabel}}\n{{xd.listing.location.streetAddress}}, {{xd.listing.location.city}}, {{xd.listing.location.state}} {{xd.listing.location.zip}}"
                },
                "field05": {
                    "type": "standardVariable",
                    "value": "{{#if (deepBind 'xd.program.postcards.comments.' '{{xd.event.value.eventName}}')}}{{deepBind 'xd.program.postcards.comments.' '{{xd.event.value.eventName}}'}}{{else}}{{xd.listing.description}}{{/if}}"
                },
                "field06": {
                    "type": "inlineVariable",
                    "value": "{{#if xd.listing.listedPrice}}${{number xd.listing.listedPrice}}{{/if}}"
                },
                "field09": {
                    "type": "inlineVariable",
                    "value": "{{#if xd.office.branchDisplay1}}{{xd.office.branchDisplay1}}\n{{/if}}{{#if xd.office.branchDisplay2}}{{xd.office.branchDisplay2}}\n{{/if}}{{#if xd.office.branchDisplay3}}{{xd.office.branchDisplay3}}\n{{/if}}{{#if xd.office.branchDisplay4}}{{xd.office.branchDisplay4}}\n{{/if}}{{#if xd.office.branchDisplay5}}{{xd.office.branchDisplay5}}\n{{/if}}{{#if xd.office.branchDisplay6}}{{xd.office.branchDisplay6}}{{/if}}"
                },
                "field11": {"type": "inlineVariable", "value": "{{#if xd.listing.listedPrice}}Price:{{/if}}"}
            }
        },
        "templateConfigurations": {
            "Front": {
                "field02": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Details",
                    "formatting": "format1"
                },
                "field03": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Headline",
                    "formatting": "format1"
                }
            },
            "Back": {
                "field02": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Name",
                    "formatting": "format1",
                    "isRequired": true
                },
                "field03": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Agent Information",
                    "formatting": "format1"
                },
                "field04": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Title",
                    "formatting": "format1"
                },
                "field05": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Comments",
                    "infoTip": "{{xd.test}}",
                    "formatting": "format1",
                    "useSuggested": true
                },
                "field06": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Price",
                    "inputMask": "usd",
                    "formatting": "format1"
                },
                "field09": {
                    "type": "textArea",
                    "fonts": ["Arial", "ComicSans"],
                    "label": "Agency Information",
                    "formatting": "format1"
                }
            }
        },
        "rendering": {"hiResOutputRotateMode": "none"},
        "showTextWarnings": true,
        "showMissingImageWarnings": true,
        "violationWarningsSettings": {
            "qualityMeter": {"enabled": true, "qualityLevels": {"bad": 32, "warning": 40}},
            "shapeViolationsEnabled": true,
            "regionViolationWarningEnabled": true,
            "textCropViolationWarningEnabled": true,
            "safetyLineViolationWarningEnabled": false
        },
        "ccJson": {
            "Front": {
                "field01": {
                    "isVariable": "True",
                    "allowedTabs": ["Property Photos", "Image Gallery"],
                    "isCoverMode": "True",
                    "placeholder": "True",
                    "placeholderResizeMode": "Fill"
                },
                "field02": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field03": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field04": {"locked": "True"}
            }, "Back": {
                "field01": {
                    "isVariable": "True",
                    "allowedTabs": ["Headshot Gallery", "Image Gallery"],
                    "isCoverMode": "True",
                    "placeholder": "True",
                    "placeholderResizeMode": "Fill"
                },
                "field02": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field03": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field04": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field05": {
                    "isVariable": "True",
                    "richTextMode": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "clip"
                },
                "field06": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field07": {"locked": "True"},
                "field08": {"locked": "True"},
                "field09": {
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                },
                "field10": {"locked": "True"},
                "field11": {
                    "locked": "True",
                    "isVariable": "True",
                    "textPermissions": {"allowChangeText": "True"},
                    "textPlaceholder": "True",
                    "overflowStrategy": "fitToBox"
                }
            }
        }
    }),
    authenticateState: (stateId) => ({stateId}),
    getLowResProducts: async () => res,
    getHighResProducts: async () => res,
    getWatermarkPdf: async () => ({
        "pdf": "https://imgproxy.xpressdocs.com/wm/ESEKCcYyXj_ijdFBVwrFgK1puWTmAXIQgds4ivK2kEH4Kj9ez4lf74Eovw2ZMIlWPCBNfKsux8zJEF7P3OpLyknaQefuwqFEymO9eZoe9Dygbf_kEdUxKYRbL3UM-D4utYkXnhmdUA8r8_sbRMbT_AMIV7sBML09TwAMPpzb3i4PfOex6BZAiC6cySyHN9GMCFm7k5Gu0-nFqKqyYB6OQrpnpkjD0etwonjRMU4zeKc=|yEgCIrkwFDeCWd0qm7vkHw==",
    }),
    checkImages: async () => [{"url": "22398131", "available": false, "status": 404}, {
        "url": "",
        "available": false,
        "status": 404
    }],
});

const res = {
    "jpg": [
        "https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80",
    ],
};
